import { VisibilityOff, Visibility } from "@mui/icons-material";
import { InputAdornment, IconButton } from "@mui/material";
import React from "react";

interface ChildComponentProps {
  show: boolean;
  setShow: (value: boolean) => void;
}

const EndEndorment: React.FC<ChildComponentProps> = ({ show, setShow }) => {
  return (
    <InputAdornment position="end">
      <IconButton
        aria-label="toggle password visibility"
        onClick={() => setShow(!show)}
        onMouseDown={(event) => event.preventDefault()}
        edge="end"
      >
        {show ? <VisibilityOff /> : <Visibility />}
      </IconButton>
    </InputAdornment>
  );
};

export default EndEndorment;
